import React, { Dispatch, SetStateAction } from "react";
import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { GalleryListElement } from "../GalleryItem/GalleryItem";

import "./GallerySelectAll.scss";

interface Props {
  posts: GalleryListElement[];
  selectedPostIds: string[];
  setSelectedPostIds: Dispatch<SetStateAction<string[]>>;
}

export const GallerySelectAll = (props: Props) => {
  const { posts, selectedPostIds, setSelectedPostIds } = props;

  const postsWithUrlsCount = posts.filter((post) => Boolean(post.url)).length;

  const checked =
    postsWithUrlsCount === selectedPostIds.length && postsWithUrlsCount > 0;

  const toggleChecked = () => {
    if (postsWithUrlsCount === selectedPostIds.length) {
      setSelectedPostIds([]);
    } else {
      setSelectedPostIds(posts.map((post) => post.url).filter(Boolean));
    }
  };

  return (
    <div className="gallery-select-all">
      <CustomCheckbox
        id="gallery-checkbox-all"
        name="gallery-checkbox-all"
        checked={checked}
        onChange={toggleChecked}
        data-qa="gallery-checkbox-all"
      />
      <label htmlFor="gallery-checkbox-all">
        <IDHFormattedMessage id="ws_select_all" defaultMessage="Select all" />
      </label>
    </div>
  );
};
